import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { setupAxiosSessionRedirect } from "@/lib/authSession";

setupAxiosSessionRedirect();

const removePageLoader = () => {
  const loader = document.getElementById("page-loader");
  if (!loader) return;
  loader.classList.add("is-hidden");
  window.setTimeout(() => loader.remove(), 350);
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

removePageLoader();
